import { createContext, useContext } from 'react';
import type { VoiceSelections } from '../../utils/voiceSettings';

/**
 * 放送地点フォームで選択中の **日本語以外の言語別話者** (`言語キー → VoiceId`) — Issue #639。
 *
 * 音声プレビューは 10 個前後のコンポーネントを経由する `parentVoiceId` (日本語の話者) で
 * 話者を受け取っている。言語別の話者まで props で通すと全コンポーネントの型を変える必要が
 * あるため、プレビュー専用の値は Context で渡す。未提供 (= 空) なら従来どおり
 * 「日本語のみ親の話者、他言語は既定話者」で試聴する。
 */
export const PreviewVoiceContext = createContext<VoiceSelections>({});

/** 現在の言語別話者 (プレビュー用)。 */
export function usePreviewVoiceSelections(): VoiceSelections {
  return useContext(PreviewVoiceContext);
}
